module.exports = __webpack_public_path__ + "static/SunflowerOil-4d3817e3dbd70e3a6b011c0172b00146.webp";